

export function buildFormData(data, parentKey=null, formData=new FormData()) {
  if (data && Array.isArray(data)){
    data.forEach(val => {
      buildFormData(val, parentKey ? `${parentKey}[]` : 'a[]', formData);
    });
  }else if (data && typeof data === 'object' && !(data instanceof Date) && !(data instanceof File)) {
    Object.keys(data).forEach(key => {
      buildFormData(data[key], parentKey ? `${parentKey}[${key}]` : key, formData);
    });
  } else {
    const value = data === null ? '' : data;
    formData.append(parentKey, value);
  }
  return formData;
}
